// extracted by mini-css-extract-plugin
module.exports = {"viewport":"_37nEq","vMobile":"_2F7Da","container":"_1XS-G","shownItems":"_3SMx0","viewTitle":"XMZMX"};